<template>
  <div class="item">
    <!-- header -->
    <div class="header flex center gaps">
      <div class="box">
        <small>
          {{ index + 1 }}.実数型
        </small>
      </div>
      <div class="box grow" />
      <div class="box">
        <el-button
          v-if="!isSetConfigSource"
          type="text"
          size="small"
          class="deleteButton"
          @click="$emit('deleteItem', index)"
        >
          削除
        </el-button>
      </div>
    </div>

    <!-- inputs -->
    <div class="inputs flex center gaps">
      <div class="box">
        <small>
          項目名:
        </small>
      </div>
      <div class="box">
        <el-input
          v-model="item.name"
          size="small"
        />
      </div>
      <div class="box grow" />
    </div>

    <!-- checkboxes -->
    <div class="checkboxes">
      <el-checkbox v-model="item.enabled">
        有効
      </el-checkbox>
      <el-checkbox v-model="item.required">
        必須項目
      </el-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminOrderCustomFieldItemsFloat",
  props: {
    item: Object,
    index: Number,
    isSetConfigSource: Boolean,
  },
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/custom-fields.scss";
</style>
